


// import React, { useEffect, useState } from "react";
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import "./Career.css";
// import careerImg from "../Images/career-bg.jpg";
// import { 
//   FaBriefcase,
//   FaUsers,
//   FaRegClock,
//   FaMapMarkerAlt 
// } from "react-icons/fa";

// const Career = () => {
//   const [jobs, setJobs] = useState([]);
//   const [loading, setLoading] = useState(true);


//   const [showModal, setShowModal] = useState(false);
// const [selectedJob, setSelectedJob] = useState(null);




//   // Fetch careers API
//   useEffect(() => {
//     fetch("https://infosightapi.emedha.in/api/careers")
//       .then((res) => res.json())
//       .then((data) => {
//         setJobs(data);
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));
//   }, []);

//   return (
//     <>
//       <Navbar />

//       {/* Hero Banner */}
//       <section
//         className="career-hero"
//         style={{ backgroundImage: `url(${careerImg})` }}
//       >
//         <div className="container">
//           <h1>Careers</h1>
//           <p>
//             <a href="/">Home</a> / Careers
//           </p>
//         </div>
//       </section>

//       {/* Careers Section */}
//       <section className="career-list">
//         <div className="container">
//           <h2>Join Infosight</h2>
//           <p className="career-sub">
//             Explore opportunities to grow and build your future with us.
//           </p>

//           {/* Loader */}
//           {loading && <div className="loading">Fetching openings...</div>}

//           {/* No jobs */}
//           {!loading && jobs.length === 0 && (
//             <p className="no-jobs">No job openings available at the moment.</p>
//           )}
// <div class="jobs-wrapper">
     
//             {jobs.map((job, idx) => (
//               <div key={idx} className="job-card">
//                 <div className="job-header">
//                   <h3>  <FaBriefcase className="job-icon"/> {job.post}</h3>


//                 </div>

//                 <p className="job-desc">{job.description}</p>

//                 <div className="job-meta">
//                   <span className="exp-tag"><FaRegClock/> Experience: {job.experience}+ yrs</span>
//                 </div>
//                   {/* moved vacancy tag here ✅ */}
//   <div className="job-meta">
//     <span className="exp-tag">
//       <FaUsers/> {job.vacancies} Vacancies
//     </span>
//   </div>
// <button
//   type="button"
//   className="apply-btn"
//   onClick={(e) => {
//     e.stopPropagation();
//     e.preventDefault();
//     console.log("clicked");   // debugging
//     setSelectedJob(job.post);
//     setShowModal(true);
//   }}
// >
//   Apply Now
// </button>



//               </div>
//             ))}
    
//           </div>
//         </div>
//       </section>
// {showModal && (
//   <div className="apply-overlay">
//     <div className="apply-modal">
//   <div className="modal-header">
//         <h2>Apply for {selectedJob}</h2>
//         <button
//           type="button"
//           className="close-btn"
//           onClick={() => setShowModal(false)}
//         >
//           Close
//         </button>
//       </div>
//      <form
//   className="apply-form"
//   onSubmit={async (e) => {
//     e.preventDefault();

//     const form = new FormData(e.target);

//     const res = await fetch("https://infosightapi.emedha.in/api/apply", {
//       method: "POST",
//       body: form
//     });

//     const text = await res.text();

//     if (text === "success") {
//       alert("✅ Application Submitted Successfully!");
//       setShowModal(false);
//     } else {
//       alert("❌ Error submitting application.");
//     }
//   }}
// >

//         <input type="hidden" name="job_title" value={selectedJob} />

//         <label>Full Name</label>
//         <input type="text" name="name" required />

//         <label>Email</label>
//         <input type="email" name="email" required />

//         <label>Mobile</label>
//         <input type="text" name="mobile" required />

//         <label>Upload Resume</label>
//         <input type="file" name="resume" accept=".pdf,.doc,.docx" required />

//         <button className="submit-btn" type="submit">
//           Submit Application
//         </button>

       
//       </form>
//     </div>
//   </div>
// )}

//       <Footer />
//     </>
//   );
// };

// export default Career;

import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./Career.css";
import careerImg from "../Images/career-bg.jpg";
import { FaBriefcase, FaUsers, FaRegClock, FaChevronDown, FaChevronUp } from "react-icons/fa";

const Career = () => {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedJob, setSelectedJob] = useState(null);

  // Track which cards are expanded
  const [expandedJobs, setExpandedJobs] = useState({});

  useEffect(() => {
    fetch("https://infosightapi.emedha.in/api/careers")
      .then((res) => res.json())
      .then((data) => {
        setJobs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const toggleJobSections = (id) => {
    setExpandedJobs((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      <Navbar />

      <section className="career-hero" style={{ backgroundImage: `url(${careerImg})` }}>
        <div className="container">
          <h1>Careers</h1>
          <p>
            <a href="/">Home</a> / Careers
          </p>
        </div>
      </section>

      <section className="career-list">
        <div className="container">
          <h2>Join Infosight</h2>
          <p className="career-sub">Explore opportunities to grow and build your future with us.</p>

          {loading && <div className="loading">Fetching openings...</div>}
          {!loading && jobs.length === 0 && <p className="no-jobs">No job openings available at the moment.</p>}

          <div className="jobs-wrapper">
            {jobs.map((job, idx) => {
              const isExpanded = expandedJobs[job.id];

              return (
                <div key={idx} className="job-card">
                  {/* Header */}
                  <div className="job-header">
                    <h3>
                      <FaBriefcase className="job-icon" /> {job.post}
                    </h3>
                  </div>

                  {/* Basic Info */}
                  <div className="job-meta">
                    <span className="exp-tag">
                      <FaRegClock /> Experience: {job.experience}+ yrs
                    </span>
                    <span className="exp-tag">
                      <FaUsers /> {job.vacancies} Vacancies
                    </span>
                  </div>

                  {/* Description */}
                  <p className="job-desc">{job.description}</p>

                  {/* Toggle Sections */}
                  {job.sections && job.sections.length > 0 && (
                    <div
                      className="toggle-sections"
                      onClick={() => toggleJobSections(job.id)}
                      style={{ cursor: "pointer", color: "#132e55", fontWeight: "bold", marginBottom: 10 }}
                    >
                      {isExpanded ? (
                        <>
                          Hide Details <FaChevronUp />
                        </>
                      ) : (
                        <>
                          View Details <FaChevronDown />
                        </>
                      )}
                    </div>
                  )}

                  {/* Sections (Collapsible) */}
{isExpanded && (
  <div
    className="job-section"
    style={{
      maxHeight: 250,       // scroll if too long
      overflowY: "auto",
      marginTop: 10,
      padding: "10px",
      background: "#f9f9f9",
      borderRadius: 6,
    }}
  >
    {job.sections.map((section, i) => (
      <div key={i} style={{ marginBottom: 10 }}>
        <h4>{section.heading}</h4>
        <p style={{ whiteSpace: "pre-line", margin: 0 }}>{section.content}</p>
      </div>
    ))}
  </div>
)}



                  {/* Apply Button */}
                  <button
                    type="button"
                    className="apply-btn"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedJob(job.post);
                      setShowModal(true);
                    }}
                  >
                    Apply Now
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Modal */}
      {showModal && (
        <div className="apply-overlay">
          <div className="apply-modal">
            <div className="modal-header">
              <h2>Apply for {selectedJob}</h2>
              <button type="button" className="close-btn" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
            <form
              className="apply-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const form = new FormData(e.target);
                const res = await fetch("https://infosightapi.emedha.in/api/apply", {
                  method: "POST",
                  body: form,
                });
                const text = await res.text();
                if (text === "success") {
                  alert("✅Application submitted successfully. Our team will contact you");
                  setShowModal(false);
                } else {
                  alert("❌ Error submitting application.");
                }
              }}
            >
              <input type="hidden" name="job_title" value={selectedJob} />
              <label>Full Name</label>
              <input type="text" name="name" required />
              <label>Email</label>
              <input type="email" name="email" required />
              <label>Mobile</label>
              <input type="text" name="mobile" required />
              <label>Upload Resume</label>
              <input type="file" name="resume" accept=".pdf,.doc,.docx" required />
              <button className="submit-btn" type="submit">
                Submit Application
              </button>
            </form>
          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Career;
